export default "__VITE_ASSET__vk4bN32b__"